<template>
<div class="containerNcm">
   <div class="painel2">
       <img src="https://www.lefisc.com.br/sandboxfront/tv/img/TVLefiscc.svg" alt="" > 
    </div>
    <main>
        <div style="display: flex;justify-content: flex-end;margin-top: 30px;">
            
    <button style="background:#D6652B;color:#fff" class="btnFavo" @click="favoritar()"><img src="/siteNew/star.svg" alt=""> Favoritar</button><button class="btnVoltar" @click="voltar()" >Voltar</button>
        </div>
        <div class="titulo2" id="video" style="margin-top: 0;">
            <p>{{found.titulo}}</p> 
        </div>
        <div style="margin:0 auto;max-width:980px;margin-top:30px;" >
            <Media @click="visuaza()" v-if="linkYou"
                    :kind="'video'"
                    :controls="true"
                    :src="[found.link]"
                    :style="{width: '980px',borderRadius:'10px',height:'550px'}"
                    >
                    </Media>
            <iframe  @click="visuaza()" v-if="!linkYou" width="980" height="550" :src="found.link" style="border-radius:10px;"></iframe>
    <p v-html="found.descricao"></p>
            
        </div>
         <div class="titulo2">
            <p s>Vídeos relacionados</p> <p></p>
        </div>
        <div class="videoRelacionados" v-if="quarto.length != 0">
                <div class="cardRelacionado" v-for="a in quarto" :key="a.$id" @click="irParaV(a.idTV,a.idCategoria,a.link,a.titulo,a.visualizacoes)">
                    <img :src="a.miniatura" alt="" width="100%" > 
                    <p style="color: #808080;margin-top:5px;">{{a.data}}</p>
                    <p style="color: #808080;font-weight:bold;">{{a.titulo.substring(0,60)}}</p>                   
                </div>
        </div>
        <div v-else>
            <p style="    margin-top: 30px;
    text-align: center;">Nenhum  vídeo relacionado</p>
        </div>
        <div class="verMais">
            <a @click="verMais()">Ver mais</a>
        </div>
        <div class="voltarBu">
            <button @click="voltar()">Voltar</button>
        </div>
        <div class="Mdes" :style="{background,top}">
      {{texto}}
  </div>
    </main>
</div>
</template>

<script>
import Media from '@dongido/vue-viaudio'
import config from '../services/config.js'
export default {  
    components:{
        Media
    }, 
    data(){
        return{
            background:'',
            top:'-300px',
            texto:'dasdasd',
            videos:[],
            found:{},     
            quarto:[],    
            linkYou:false,
      reqie:true,

        }
    },
    methods:{
        readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        },
        voltar(){           
            this.$router.push({
                name:'home',
            })            
        },
        async favoritar(){            
            const hash = this.readCookie("hash")      
            if(this.reqie){
                this.reqie = false
            
            let res = await config.postFavorito({
                "produto": this.$route.params.idTv,
                "categoria": 7,
                "hash": hash
                })
           if(res.status <=204){
        this.texto ='Adicionado nos favoritos'
        this.background='green'
        this.top='50px'    
          
        setTimeout(() => {
          this.top='-200px'   
          this.reqie = true
        },3500)
      }else{
        this.texto ='Erro ao adicionar'
        this.background='#ff1a1a'
        this.top='50px'  
       
        setTimeout(() => {
          this.top='-200px'  
          this.reqie = true
        },3500)
      }
      }
        },
        visuaza(){   
            let id =  0                       
            for(let i =0; i <this.videos.length ;i++){
                if(this.$route.params.idTv == this.videos[i].idTV){
                    console.log(this.$route.params.idTv,this.videos[i].idTV)
                    this.videos[i].visualizacoes = this.videos[i].visualizacoes + 1
                    id = i
                }
            }         
            this.somarMaisUmVisualizaoes(this.videos[id].visualizacoes,this.$route.params.idTv)
        },
        irParaV(idTv,categoria,link,titulo,visualizacoes,descricao){
            clearInterval()
            location.href = "#video"
            this.$router.push({
            name:'video',
            params:{idTv,categoria}
          })
          this.found.link = link
          this.found.titulo = titulo
          this.found.visualizacoes = visualizacoes
          let isYou = new RegExp(/\.xml/)
          this.linkYou = isYou.test(this.found.link)
        this.found.descricao =     descricao    
        setTimeout(async () => {
            
            await this.visuaza()
        }, 15000);
        },
        verMais(){
            this.$router.push({
                name:'home',
            })    
        },
        async getTodas(){          
            this.videos = await config.porCategoriaUltimas(this.$route.params.categoria) 
            this.found = this.videos.find(element => element.idTV == this.$route.params.idTv)
            for(let i =0 ; i< 5;i++){
                if(this.videos[i] != undefined){
                    if(this.videos[i].idTV != this.found.idTV){
                        this.quarto.push(this.videos[i])
                    }
                    
                }
                
            }            
            this.ajusteData(this.quarto)      
               
        },  
        async somarMaisUmVisualizaoes(visu,idtv){
            await config.Add1visualizacao(visu,idtv)
        },
        ajusteData(elemento){
          elemento.forEach(element => {
              element.data = element.data.substring(8,10) + '/'+element.data.substring(5,7) +'/'+element.data.substring(0,4)
          });
      }           
    },
    async mounted(){
       window.scrollTo(0,0)
        await this.getTodas()
        console.log('vindo')
        setTimeout(async () => {
            await this.visuaza()
        }, 5000);
        
    } 
}
</script>

<style>

.Mdes{   
    min-width: 230px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-radius: 5px;   
    position: fixed;
    min-height: 80px;
    max-width: 300px;
    padding: 20px;
    top:-200px;
    z-index: 101;
   left: 0; 
  right: 0; 
  margin-left: auto; 
  margin-right: auto; 
    transition: 0.5s all;
    color: #fff;
    font-weight: 600;
    box-shadow: 5px 5px 15px 5px rgba(0,0,0,0);
}
button:focus{
    outline: none;
}
.btnVoltar:hover{
    background: #D6652B;
    color:#fff;
}
.btnFavo{
    border: 2px solid #D6652B;
    border-radius: 5px;
    background: #fff;
    color: #000;
    font-size: 18px;
    font-weight: 600;
    font-style: italic;
    width: 118px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 40px;
}
.btnVoltar{
    border: 2px solid #D6652B;
    border-radius: 5px;
    background: #fff;
    color: #000;
    font-size: 18px;
    font-weight: 600;
    font-style: italic;
    width: 118px;
    height: 40px;
    margin-left: 20px;
}
.aEs{
    opacity: 1;
    text-decoration: none;
    color:#000;
    width: 100%;
    height: 100%;
}
.aEs:hover{
 text-decoration: none;
}
.voltarBu{
    display: flex;
    justify-content: center;
    margin-top:70px;  
}
.voltarBu button:hover{
    background: #D6652B;
    color:#fff;
}
.voltarBu button{
    width: 153px;
    height: 62px;
    border: 2px solid #D6652B;
    border-radius: 5px;
    background: #fff;
    font-size: 28px;
    font-weight: 600;
    font-style: italic;
    margin-bottom: 40px;
}
.voltarBu button:focus{
    outline: none;
}
.verMais{
    display: flex;
    justify-content: flex-end;
    margin-top:10px;
}
.verMais a{
    color: #808080;
    font-weight: bold;
    font-size: 19px;
    font-style: italic;
    cursor: pointer;
}
.containerNcm{
    margin:0 auto;
    max-width: 1160px; 
    background: #fff;
}
.painel2{
    background-image: url('https://www.lefisc.com.br/sandboxfront/tv/img/lanterna.jpg');
    background-color: #D6652B;
    background-blend-mode: multiply;
    height: 17vh;
    width: 100%; 
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
.painel2 img{
    width: 110px;
    color:#fff;
}
main{
    margin:0 auto;
    max-width: 1050px;
}
main .titulo2{
    margin-top:27px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 10px;
    border-bottom: 1px solid #808080;
    
}
main .titulo2 p{
    color: #808080;
    font-weight: bold;
    font-style: italic;
    font-size: 24px;
    margin-bottom: 0px;
    margin-top: 13px;
    margin-right:50px;
}
main .titulo2 button{
    border: 2px solid #D6652B;
    border-radius: 5px;
    background: #fff;
    color:#000;
    font-size: 18px;
    font-weight: 600;
    font-style: italic;
    width: 118px;
    height: 40px;
}
main .titulo2 button:hover{
    background: #D6652B;
    color:#fff;
}
main .titulo2 button:focus{
    outline: none;
}
.videoRelacionados{
    display: flex;
    margin-top:28px;
}
.videoRelacionados .cardRelacionado{
    width: 252px;
    height: 235px;
    border: 1px solid #707070;
    border-radius: 10px;
    margin-left: 16px;
    cursor: pointer;
}
.videoRelacionados .cardRelacionado{
    font-size:14px
}
.videoRelacionados .cardRelacionado:nth-child(1){
    margin-left:0px;
}
.videoRelacionados .cardRelacionado img{
      border-top-left-radius: 9px;
  border-top-right-radius: 9px;
}
.videoRelacionados .cardRelacionado p{
  margin-bottom: 0px;
  margin-left:9px;
  margin-right:9px;
}
</style>